import ActiveRecord from './active_record/base'

class BillingActivity extends ActiveRecord {
	static tableName = 'billingActivities'
}

export default BillingActivity
